import { vars } from "./contract.css";

import type { CSSProperties } from "react";

export type SizeValue<Preset extends string> = Preset | number | (string & {});

export type ResolvedSize<Preset extends string> = {
  variant: Preset | "custom";
  style?: CSSProperties;
};

export function isSizePreset<Preset extends string>(
  size: SizeValue<NoInfer<Preset>>,
  presets: readonly Preset[],
): size is Preset {
  return (
    typeof size === "string" && (presets as readonly string[]).includes(size)
  );
}

export function sizeToCss(size: number | string): string {
  return typeof size === "number" ? `calc(${size} * ${vars.unit.px})` : size;
}

export function resolveSize<Preset extends string>(
  size: SizeValue<NoInfer<Preset>>,
  presets: readonly Preset[],
  cssVar: string,
): ResolvedSize<Preset> {
  if (isSizePreset(size, presets)) {
    return { variant: size };
  }

  return {
    variant: "custom",
    style: { [toPropertyName(cssVar)]: sizeToCss(size) } as CSSProperties,
  };
}

function toPropertyName(cssVar: string): string {
  const match = /^var\((--[^,)]+)/.exec(cssVar);

  return match ? match[1] : cssVar;
}
